import React from 'react';

import styles from './index.module.sass';

const ErrorBox = ({ children, className = '' }) => (
  <div className={`p-6 ${className} ${styles.component}`}>{children}</div>
);

export default ErrorBox;
